// action/customerActions.js
import { customerAPI } from './api';

export const customerActions = {
    // Get customers with proper error handling
    getCustomers: async (params = {}) => {
        try {
            const response = await customerAPI.getAll(params);
            
            // Handle different response structures
            if (response.data && Array.isArray(response.data)) {
                return { 
                    success: true, 
                    data: response.data
                };
            } else if (response.customers && Array.isArray(response.customers)) {
                return { 
                    success: true, 
                    data: response.customers
                };
            } else if (Array.isArray(response)) {
                return { 
                    success: true, 
                    data: response
                };
            } else if (response.data && response.data.customers) {
                return { 
                    success: true, 
                    data: response.data.customers
                };
            }
            
            return { success: false, message: 'No customers found', data: [] };
        } catch (error) {
            console.error('Error fetching customers:', error);
            return { 
                success: false, 
                message: error.response?.data?.message || 'Failed to fetch customers',
                data: []
            };
        }
    },

    // Create new customer
    create: async (customerData) => {
        try {
            // Validate required fields
            if (!customerData.name || customerData.name.trim() === '') {
                return { success: false, message: 'Customer name is required' };
            }
            
            const response = await customerAPI.create(customerData);
            
            console.log('Customer create API response:', response);
            
            // Handle different response structures
            if (response && response.success) {
                return { 
                    success: true, 
                    data: response.data || response.customer || response,
                    message: response.message || 'Customer created successfully'
                };
            } else if (response && response.id) {
                return { 
                    success: true, 
                    data: response,
                    message: 'Customer created successfully'
                };
            } else if (response && response.data && response.data.id) {
                return { 
                    success: true, 
                    data: response.data,
                    message: response.message || 'Customer created successfully'
                };
            } else {
                return { 
                    success: false, 
                    message: response?.message || 'Failed to create customer' 
                };
            }
        } catch (error) {
            console.error('Error creating customer:', error);
            return { 
                success: false, 
                message: error.response?.data?.message || error.message || 'Failed to create customer' 
            };
        }
    },

    // Update customer
    update: async (id, customerData) => {
        try {
            const response = await customerAPI.update(id, customerData);
            
            if (response && response.success) {
                return { 
                    success: true, 
                    data: response.data || response,
                    message: 'Customer updated successfully'
                };
            } else {
                return { 
                    success: false, 
                    message: response?.message || 'Failed to update customer' 
                };
            }
        } catch (error) {
            console.error('Error updating customer:', error);
            return { 
                success: false, 
                message: error.response?.data?.message || 'Failed to update customer' 
            };
        }
    },

    // Delete customer
    delete: async (id) => {
        try {
            const response = await customerAPI.delete(id);
            
            if (response && response.success) {
                return { 
                    success: true, 
                    message: 'Customer deleted successfully'
                };
            } else {
                return { 
                    success: false, 
                    message: response?.message || 'Failed to delete customer' 
                };
            }
        } catch (error) {
            console.error('Error deleting customer:', error);
            return { 
                success: false, 
                message: error.response?.data?.message || 'Failed to delete customer' 
            };
        }
    },

    // Get customer by ID
    getCustomer: async (id) => {
        try {
            const response = await customerAPI.get(id);
            
            if (response && response.id) {
                return { 
                    success: true, 
                    data: response
                };
            } else if (response && response.data) {
                return { 
                    success: true, 
                    data: response.data
                };
            } else {
                return { 
                    success: false, 
                    message: 'Customer not found' 
                };
            }
        } catch (error) {
            console.error('Error fetching customer:', error);
            return { 
                success: false, 
                message: error.response?.data?.message || 'Failed to fetch customer' 
            };
        }
    },

    // Search customers by phone
    searchByPhone: async (phone) => {
        try {
            const response = await customerAPI.search({ phone });
            
            if (response.data && response.data.length > 0) {
                return { 
                    success: true, 
                    data: response.data[0]
                };
            } else if (Array.isArray(response) && response.length > 0) {
                return { 
                    success: true, 
                    data: response[0]
                };
            } else {
                return { 
                    success: false, 
                    message: 'Customer not found' 
                };
            }
        } catch (error) {
            console.error('Error searching customer:', error);
            return { 
                success: false, 
                message: error.response?.data?.message || 'Failed to search customer' 
            };
        }
    }
};

export default customerActions;